import { lazy, Suspense } from 'react'

import { FormBlockerElementCashAppTagElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

const CardTagOrderConfirmationHero = lazy(() =>
  import('@cash-web/shared-card-studio-feature-main').then(module => ({
    default: module.CardTagOrderConfirmationHero,
  }))
)

const CashAppTagHero = lazy(() =>
  import('@cash-web/shared-card-studio-feature-main').then(module => ({
    default: module.CashAppTagHero,
  }))
)

export const CashAppTagElement = ({ card_theme_token, tag_theme_token }: FormBlockerElementCashAppTagElement) => {
  if (!tag_theme_token) {
    throw new Error('CashAppTagElement requires tag_theme_token')
  }

  return (
    <Suspense fallback={null}>
      {card_theme_token ? (
        <CardTagOrderConfirmationHero cardThemeToken={card_theme_token} tagThemeToken={tag_theme_token} />
      ) : (
        <CashAppTagHero tagThemeToken={tag_theme_token} />
      )}
    </Suspense>
  )
}
